export default __webpack_public_path__ + "static/media/music.e2eaa3e5.mp3";